// src/utils/getInvoiceUrl.js
export const getInvoiceUrl = (systemInvoice, currentUrl) => {

    const invoiceMap = {
        invoice: 'invoice',
        invoice2: 'invoice_fm2',
        invoice3: 'invoice_fm3',
        invoice4: 'invoice_fm4',
        invoice5: 'invoice_fm5',
        invoice5_landscape: 'invoice_fm5_landscape',
        invoice6: 'invoice_fm6',
        invoice7: 'invoice_fm7',
        invoice8_optical: 'invoice_fm8_optical',
        invoice8: 'invoice_fm8',
        BKGargMetalAlloy: "ItemWiseBill",


        AAYPEE : "ItemWiseBillNeW",
        PremChand : "ItemWiseBillNeW",
        PoSock : "poSockBill"
    };

    const path = invoiceMap[systemInvoice];
    return path ? `${currentUrl}/${path}` : null;
}
